import React from 'react';
import ColorPicker from './ColorPicker';
import {
    CreateLabelSection,
    SectionTitle,
    LabelInput,
    Button
} from '../../styles/LabelPicker.styles';

const CreateLabelForm = ({
    title,
    onTitleChange,
    selectedColor,
    onColorSelect,
    onCreateLabel,
    onDeleteLabel,
    isEditing = false,
    labelName = "Create"
}) => (
    <CreateLabelSection>
        <SectionTitle>{isEditing ? "Edit label" : "Create new label"}</SectionTitle>
        <LabelInput
            value={title}
            onChange={e => onTitleChange(e.target.value)}
            placeholder="Label title"
        />

        <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={onColorSelect}
        />

        <div style={{ display: 'flex', gap: '8px' }}>
            <Button
                onClick={onCreateLabel}
                disabled={!title.trim()}
            >
                {isEditing ? (labelName || "Save") : "Create"}
            </Button>
            {isEditing && onDeleteLabel && (
                <Button
                    onClick={onDeleteLabel}
                    style={{ backgroundColor: '#ff6b6b' }}
                >
                    Delete
                </Button>
            )}
        </div>
    </CreateLabelSection>
);

export default CreateLabelForm;
